import { render, staticRenderFns } from "./LGlobal.vue?vue&type=template&id=19cace2a&scoped=true"
import script from "./LGlobal.vue?vue&type=script&lang=js"
export * from "./LGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cace2a",
  null
  
)

export default component.exports